// 🔧 store_report.js
// ✅ Purpose: Builds standardized reports for Event Merch Store Demo Engine
// ✅ Features:
// - Reports store products created
// - Reports product variants created
// - Returns Demo Report v2-compatible structured results
// - Fully block-commented for clarity and future devs

export const buildStoreReport = ({
  storeResults,
} = {}) => {
  const products = storeResults?.products || [];
  const variants = storeResults?.variants || [];

  return {
    success: true,

    created: {
      storeProducts: products.length,
      storeVariants: variants.length,
    },

    summary: [
      `${products.length} Store Products`,
      `${variants.length} Variants`,
    ].join(" • "),
  };
};